import script from "./CookieBanner.vue?vue&type=script&lang=ts&setup=true"
export * from "./CookieBanner.vue?vue&type=script&lang=ts&setup=true"

import "./CookieBanner.vue?vue&type=style&index=0&id=49d5f6d4&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49d5f6d4"]])

export default __exports__